import { SchedulerModel } from '../models/scheduler_model';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import * as _4 from 'lodash4';
import { ICustomTextEntry } from '../../../interfaces/scheduler_interfaces';

angular
  .module('capability-ng-scheduler')
  .factory(
    'getSchedulerConfigCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSchedulerModel: SchedulerModel,
      log: any
    ): ICommand => {
      return defineCommandORM(
        'getSchedulerConfigCommand',
        (deferred: ng.IDeferred<IQuery[]>, termId: number): ng.IPromise<void> => {
          return $http({
            method: 'GET',
            url: `item/customtext`
          })
            .then(({ data }: { data: ICustomTextEntry[] }) => {
              ngSchedulerModel.write({
                customtext: _4.keyBy(data, 'nk')
              });
              deferred.resolve();
            })
            .catch((e) => {
              log.issue('Failed to get scheduler configuration');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/get_scheduler_config_command.ts